import { ChangeDetectorRef, Component, Injector, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ActivityServiceProxy, ApplicationAndSpendTimeDto, CalculationTimeAndAttendanceDto, InputeTypeWiseCategoryAndApplicationDto, ProdData, ProductivityBarServiceProxy, ProductivityTypes, TimeAndAttendanceReportServiceProxy, UserWiseProductiveUnproductiveAndNuetralTimeDto } from '../../../../../shared/service-proxies/service-proxies';
import { ActivityService } from '../../../activities/services/activity.service';
import { Subscription } from 'rxjs';
import { DateTime } from 'luxon';
import { Workbook } from 'exceljs';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import jsPDF from 'jspdf';
import * as fs from 'file-saver';
import { TimesheetUtilityService } from '@app/main/time-sheet-new/services/timesheet-utility.service';
import { AbpSessionService } from 'abp-ng2-module';
import { MonitoringService } from '@app/shared/common/telemetry-implementation/MonitoringService ';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ThemeModeHelper } from '@shared/helpers/ThemeModeHelper';
@Component({
    standalone: false,
    selector: 'app-dashboard-productivity-info-section',
    templateUrl: './dashboard-productivity-info-section.component.html',
    styleUrls: ['./dashboard-productivity-info-section.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardProductivityInfoSectionComponent extends AppComponentBase implements OnInit, OnDestroy {
    @ViewChild("timeAndAttendanceTabs", { static: false })
    timeAndAttendanceTabs: TabsetComponent;
    allPendingDataForExport: import('../../../../../shared/service-proxies/service-proxies').PendingApplicationInfo[];
    allApprovedDataForExport: import('../../../../../shared/service-proxies/service-proxies').PendingApplicationInfo[];
    areas: {
        appName: string;
        area: number;
    }[] = [];
    pies: any;
    prouctive: any;
    applications: ApplicationAndSpendTimeDto[];
    userId = abp.session.userId;
    tenantId = abp.session.tenantId;
    firstPieChart: UserWiseProductiveUnproductiveAndNuetralTimeDto[];
    leftPieChartPercentageArray: number[];
    subscription: Subscription;
    userStats: CalculationTimeAndAttendanceDto;
    showEmptyScreenUI: boolean = false;
    datePipe: any;
    resolveOverlappingTypes = ['shift', 'hide', 'none'];
    dateTime = new Date();
    msg: string;
    pieColorPalette = [];
    readonly categoryPieColors = ['#7ab8eb', '#5a9fd4', '#3d85bd', '#2b6fa3', '#1a5a8a', '#4a90c8', '#6ba3d6'];
    readonly chartHostStyle = { width: '100%', height: '100%' };
    private themeObserver?: MutationObserver;
    areasPieChartOptions = this.buildPieChartOptions(true);
    categoryPieChartOptions = this.buildPieChartOptions(false);
    areasPieChartData = this.buildAreasPieChartData();
    categoryPieChartData = this.buildCategoryPieChartData();
    isApplicationSidebarOpen = false;
    applicationSearchString = '';
    applicationsForSearch: ApplicationAndSpendTimeDto[] = [];
    applicationSidebarEmpty = false;
    constructor(private _abpSessionService: AbpSessionService, private _monitorService: MonitoringService, private cdRef: ChangeDetectorRef, private _activityService: ActivityService, private _activitesServiceProxy: ActivityServiceProxy, public _tus: TimesheetUtilityService, injector: Injector, private _productivityBarServiceProxy: ProductivityBarServiceProxy,
            private _timeAndAttendanceReportServiceProxy: TimeAndAttendanceReportServiceProxy
    ) { super(injector); }
    ngOnInit(): void {
        this.msg = "userId = " + this._abpSessionService.userId + "tenantId =" + this._abpSessionService.tenantId;
        this._monitorService.logPageView("UI-dashboardProductivityInfoSection");
        this.getTypeBaseApplicationSpendTime();
        this.getAllDataForExport();
        this.getAllApplicationForUser();
        this.observeThemeChanges();
    }

    private buildPieChartOptions(isDoughnut: boolean) {
        const legendColor = ThemeModeHelper.getCurrentMode() === 'dark' ? '#e8e8e8' : '#3f4254';
        return {
            responsive: true,
            plugins: {
                legend: {
                    position: 'bottom' as const,
                    align: 'center' as const,
                    labels: {
                        color: legendColor,
                        boxWidth: 12,
                        boxHeight: 12,
                        padding: 16,
                        font: { size: 12 },
                    },
                },
                tooltip: {
                    callbacks: {
                        label: (ctx: { label: string; parsed: number }) => `${ctx.label}: ${ctx.parsed}%`,
                    },
                },
            },
            ...(isDoughnut ? { cutout: '55%' } : {}),
            maintainAspectRatio: false,
            layout: { padding: { top: 8, bottom: 4, left: 8, right: 8 } },
        };
    }

    private observeThemeChanges(): void {
        if (typeof MutationObserver === 'undefined' || typeof document === 'undefined') {
            return;
        }
        this.themeObserver = new MutationObserver(() => {
            const legendColor = ThemeModeHelper.getCurrentMode() === 'dark' ? '#e8e8e8' : '#3f4254';
            if (this.categoryPieChartOptions?.plugins?.legend?.labels?.color === legendColor) {
                return;
            }
            this.areasPieChartOptions = this.buildPieChartOptions(true);
            this.categoryPieChartOptions = this.buildPieChartOptions(false);
            this.cdRef.markForCheck();
        });
        this.themeObserver.observe(document.documentElement, {
            attributes: true,
            attributeFilter: [ThemeModeHelper.attributeName],
        });
    }

    ngOnDestroy(): void {
        this.themeObserver?.disconnect();
    }

    private buildAreasPieChartData() {
        const areas = this.areas ?? [];
        return {
            labels: areas.map((a) => a.appName),
            datasets: [{
                data: areas.map((a) => +(a.area * 100).toFixed(2)),
                backgroundColor: this.pieColorPalette?.length
                    ? [...this.pieColorPalette]
                    : ['#6fcefb', '#f37b87', '#e4e4e4'],
            }],
        };
    }

    private buildCategoryPieChartData() {
        const data = this.prouctive ?? [];
        return {
            labels: data.map((a: { appName: string }) => a.appName),
            datasets: [{
                data: data.map((a: { area: number | string }) => +(Number(a.area) * 100).toFixed(2)),
                backgroundColor: data.map((_: unknown, i: number) =>
                    this.categoryPieColors[i % this.categoryPieColors.length]),
            }],
        };
    }

    private chartDataEquals(
        current: { labels?: string[]; datasets?: { data: number[]; backgroundColor: string[] }[] } | undefined,
        next: { labels: string[]; datasets: { data: number[]; backgroundColor: string[] }[] }
    ): boolean {
        if (!current) {
            return false;
        }
        const currentDataset = current.datasets?.[0];
        const nextDataset = next.datasets[0];
        if (!currentDataset || !nextDataset) {
            return false;
        }
        const sameLabels = current.labels?.length === next.labels.length
            && current.labels.every((label, i) => label === next.labels[i]);
        const sameValues = currentDataset.data.length === nextDataset.data.length
            && currentDataset.data.every((value, i) => value === nextDataset.data[i]);
        const sameColors = currentDataset.backgroundColor.length === nextDataset.backgroundColor.length
            && currentDataset.backgroundColor.every((color, i) => color === nextDataset.backgroundColor[i]);
        return sameLabels && sameValues && sameColors;
    }

    private syncAreasPieChartData(): void {
        const next = this.buildAreasPieChartData();
        if (!this.chartDataEquals(this.areasPieChartData, next)) {
            this.areasPieChartData = next;
        }
    }

    private syncCategoryPieChartData(): void {
        const next = this.buildCategoryPieChartData();
        if (!this.chartDataEquals(this.categoryPieChartData, next)) {
            this.categoryPieChartData = next;
        }
    }
    getTypeBaseApplicationSpendTime() {
        var date = new Date();
        this._monitorService.logTrace("UI-getTypeBaseApplicationSpendTime", { "getTypeBaseApplicationSpendTime ": "getUserWiseProductiveUnProductiveAndNuetralData: " + this + this.dateTime });
        this._productivityBarServiceProxy.getUserWiseProductiveUnProductiveAndNuetralData(this.userId, this.tenantId, DateTime.fromJSDate(this._activityService.setZeroTimeForLocalDate(date)), date.getTimezoneOffset()).subscribe((r) => {
            this.areas = [];
            this.pieColorPalette = [];
            this.firstPieChart = r;
            sessionStorage.setItem("applicationWiseSpentTime", JSON.stringify(r));
            let res = r;
            localStorage.setItem('appspenttime', JSON.stringify(res));
            let reducedTotalArr = r.map((r) => {
                return [
                    this.timeStampToSeconds(r.productiveTime),
                    this.timeStampToSeconds(r.unProductiveTime),
                    this.timeStampToSeconds(r.nuetralTime),
                ];
            });
            let totalArr = [0, 0, 0];
            var tot = 0;
            reducedTotalArr.forEach((r) => {
                totalArr[0] += r[0];
                totalArr[1] += r[1];
                totalArr[2] += r[2];
                tot += r[0] + r[1] + r[2];
            });
            this.leftPieChartPercentageArray = [];
            totalArr.map((r) => (r) / totalArr.reduce((a, v) => (a += v), 0));
            var a = (totalArr[0] / tot);
            this.leftPieChartPercentageArray.push(a);
            a = (totalArr[1] / tot);
            this.leftPieChartPercentageArray.push(a);
            a = (totalArr[2] / tot);
            this.leftPieChartPercentageArray.push(a);
            if (totalArr[0] == 0 && totalArr[1] == 0 && totalArr[2] == 0) {
                this.showEmptyScreenUI = true;
                return;
            }
            else {
                this.showEmptyScreenUI = false;
            }
            this.leftPieChartPercentageArray = totalArr.map((r) => (r * 100.0) / totalArr.reduce((a, v) => (a += v), 0) / 100);
            let val = [
                new ProdData({
                    id: 0,
                    key: "productive",
                    val: this.leftPieChartPercentageArray[0] * 100,
                    val2: 0
                }),
                new ProdData({
                    id: 1,
                    key: "unproductive",
                    val: this.leftPieChartPercentageArray[1] * 100,
                    val2: 0
                }),
                new ProdData({
                    id: 2,
                    key: "Neutral",
                    val: this.leftPieChartPercentageArray[2] * 100,
                    val2: 0
                })
            ];
            if (this.leftPieChartPercentageArray[0] != 0 || this.leftPieChartPercentageArray[1] != 0 || this.leftPieChartPercentageArray[2] != 0) {
                this._productivityBarServiceProxy.calculateProperPercentage(val).subscribe(res => {
                    if (this.leftPieChartPercentageArray[0] !== 0) {
                        this.areas.push({ appName: this.l("Productive"), area: res[0].val / 100 });
                        this.pieColorPalette.push('#6fcefb');
                    }
                    if (this.leftPieChartPercentageArray[1] !== 0) {
                        this.areas.push({ appName: this.l("Unproductive"), area: res[1].val / 100 });
                        this.pieColorPalette.push('#f37b87');
                    }
                    if (this.leftPieChartPercentageArray[2] !== 0) {
                        this.areas.push({ appName: this.l("Neutral"), area: res[2].val / 100 });
                        this.pieColorPalette.push('#e4e4e4');
                    }
                    this.syncAreasPieChartData();
                    this.markForCheck();
                });
            }
            else {
                if (this.leftPieChartPercentageArray[0] !== 0) {
                    this.areas.push({ appName: this.l("Productive"), area: this.leftPieChartPercentageArray[0] });
                    this.pieColorPalette.push('#6fcefb');
                }
                if (this.leftPieChartPercentageArray[1] !== 0) {
                    this.areas.push({ appName: this.l("Unproductive"), area: this.leftPieChartPercentageArray[1] });
                    this.pieColorPalette.push('#f37b87');
                }
                if (this.leftPieChartPercentageArray[2] !== 0) {
                    this.areas.push({ appName: this.l("Neutral"), area: this.leftPieChartPercentageArray[2] });
                    this.pieColorPalette.push('#e4e4e4');
                }
                this.syncAreasPieChartData();
            }
            this.markForCheck();
        });
    }
    timeStampToSeconds(seconds: string) {
        if (!seconds)
            return 0;
        let arr = seconds.split(":").map((r) => parseInt(r));
        return arr[0] * 3600 + arr[1] * 60 + arr[2];
    }
    getAllApplicationForUser() {
        try {
            let date = new Date();
            let input = new InputeTypeWiseCategoryAndApplicationDto();
            input.tenantId = this.tenantId;
            input.userId = this.userId;
            input.productivityTypes = ProductivityTypes.Neutral;
            input.isAllTypes = true;
            input.calenderDate = DateTime.fromJSDate(this._activityService.setZeroTimeForLocalDate(date));
            this._monitorService.logTrace("UI-getAllApplicationForUser", { "getAllApplicationForUser ": "getTypeWiseCategotyAndApplication: " + this.msg + this.dateTime });
            this._timeAndAttendanceReportServiceProxy
                .combineApplicationDetails(input)
                .subscribe((r) => {
                const totalAppCount = r.productiveUnProductiveNuetralDetail.reduce((a, v) => (a += v.applicationCount), 0);
                let temp: ProdData[] = [];
                let id1 = 0;
                let flag = false;
                r.productiveUnProductiveNuetralDetail.forEach(x => {
                    var t = new ProdData({
                        id: id1,
                        key: x.categoryName,
                        val: (x.applicationCount / totalAppCount) * 100,
                        val2: 0
                    });
                    id1++;
                    if (t.val > 0) {
                        flag = true;
                    }
                    temp.push(t);
                });
                if (flag) {
                    this._productivityBarServiceProxy.calculateProperPercentage(temp).subscribe(res => {
                        this.prouctive = res.map(x => {
                            return {
                                appName: x.key,
                                area: (x.val) / 100
                            };
                        });
                        this.syncCategoryPieChartData();
                        this.markForCheck();
                    });
                }
                else {
                    this.prouctive = r.productiveUnProductiveNuetralDetail.map((x) => {
                        return {
                            appName: x.categoryName,
                            area: (x.applicationCount / totalAppCount).toFixed(2),
                        };
                    });
                    this.syncCategoryPieChartData();
                }
                this.applications = (r.applicationTimeDetail ?? [])
                    .slice()
                    .sort((a, b) => this.timeStampToSeconds(b.spendTime) - this.timeStampToSeconds(a.spendTime));
                this.filterApplications();
                this.markForCheck();
            });
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }
    pointClickHandler(e) {
        let date = new Date();
        this._productivityBarServiceProxy
            .getTypeWiseCategotyAndApplication(this.tenantId, this.userId, ProductivityTypes[e.target.argument as string], false, DateTime.fromJSDate(this._activityService.setZeroTimeForLocalDate(date)), date.getTimezoneOffset())
            .subscribe((r) => {
            const totalAppCount = r.reduce((a, v) => (a += v.applicationCount), 0);
            this.prouctive = r.map((x) => {
                return {
                    appName: x.categoryName,
                    area: (x.applicationCount / totalAppCount).toFixed(2),
                };
            });
            this.syncCategoryPieChartData();
            this._productivityBarServiceProxy
                .getTypeBaseApplicationSpendTime(this.tenantId, this.userId, ProductivityTypes[e.target.argument as string], false, DateTime.fromJSDate(this._activityService.setZeroTimeForLocalDate(date)), date.getTimezoneOffset())
                .subscribe((r) => {
                this.applications = r;
                this.filterApplications();
            });
            this.markForCheck();
        });
    }
    onPointHoverChanged(e) {
        const point = e.target;
        if (!point.isHovered()) {
            point.hideTooltip();
        }
        else {
            point.showTooltip();
        }
    }
    customizeTooltip(arg) {
        return { text: `${arg.argumentText}` };
    }
    exportToPdf(e) {
        try {
            this._monitorService.logTrace("UI-exportToPdf", { "exportToPdf ": "PDF export: " + this + this.msg + this.dateTime });
            const title = 'Approved Offline Times';
            const head = [['User Name', 'Project', 'Submitted On', 'Time Registered', 'Type', 'Description']];
            let ExcelDataArray = [];
            let curData = this.allPendingDataForExport;
            curData.forEach((x) => {
                let timeRegisterd = this.datePipe.transform(this.getLocalJsDate(x.startIdealTime), 'h:mm a') + " - " + this.datePipe.transform(this.getLocalJsDate(x.endIdealTime), 'h:mm a');
                let data = [x.fullName, x.projectName, this.datePipe.transform(this.getLocalJsDate(x.submittedOn), 'MMM d, y'),
                    timeRegisterd, this.getProductivityType(x.productivityType), x.description];
                ExcelDataArray.push(data);
            });
            const doc = new jsPDF("p", "pt");
            doc.text("Time Off Approvals", 40, 30);
            doc.setFontSize(7);
            doc.setTextColor(100);
            (doc as any).autoTable({
                head: head,
                body: ExcelDataArray,
                theme: 'grid',
                tableLineColor: [189, 195, 199],
                tableLineWidth: 0.75,
                startY: 40,
                margin: {
                    top: 60
                },
                styles: {
                    fontSize: 9
                },
                columnStyles: {
                    0: {},
                    1: {},
                    2: {},
                    3: {},
                    4: {},
                    5: {},
                    6: {},
                    7: {},
                }
            });
            doc.save(`${title}.pdf`);
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }
    exportToExcel(e) {
        try {
            this._monitorService.logTrace("UI-exportToPdf", { "exportToPdf ": "PDF export: " + this + this.msg + this.dateTime });
            const title = 'Approved Offline Times';
            const head = ['User Name', 'Project', 'Submitted On', 'Time Registered', 'Type', 'Description'];
            let ExcelDataArray = [];
            let curData = this.allPendingDataForExport;
            let colWidth = head.map(s => s.length);
            curData.forEach((x) => {
                let timeRegisterd = this.datePipe.transform(this.getLocalJsDate(x.startIdealTime), 'h:mm a') + " - " + this.datePipe.transform(this.getLocalJsDate(x.endIdealTime), 'h:mm a');
                let data = [x.fullName, x.projectName, this.datePipe.transform(this.getLocalJsDate(x.submittedOn), 'MMM d, y'),
                    timeRegisterd, this.getProductivityType(x.productivityType), x.description];
                colWidth = data.map((val, idx) => Math.max(val ? val?.length : 0, colWidth[idx]));
                ExcelDataArray.push(data);
            });
            let workbook = new Workbook();
            let worksheet = workbook.addWorksheet('Offline Time');
            worksheet.addRow([]);
            worksheet.addRow(head);
            ExcelDataArray.forEach(d => {
                worksheet.addRow(d);
            });
            colWidth.forEach((w, idx) => worksheet.columns[idx].width = w);
            workbook.xlsx.writeBuffer().then((data) => {
                let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                fs.saveAs(blob, title + '.xlsx');
            });
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }
    // get local js date from a UTC datetime object
    getLocalJsDate(date: DateTime): Date {
        let jsDate = new Date(`${date.year}-${date.month < 10 ? '0' + date.month : date.month}-${date.day < 10 ? '0' + date.day : date.day}T${date.hour < 10 ? '0' + date.hour : date.hour}:${date.minute < 10 ? '0' + date.minute : date.minute}:00`);
        return new Date(jsDate.getTime() - jsDate.getTimezoneOffset() * 60 * 1000);
    }
    getProductivityType(typeId: number) {
        return ["Productive", "Unproductive", "Neutral"][typeId - 1];
    }
    async getAllDataForExport() {
        let pendingData = [];
        let approvedData = [];
        this.allPendingDataForExport = [...pendingData, ...approvedData];
    }
    viewAll() {
        localStorage.removeItem('isViewAllFromDashboard');
        this.applicationSearchString = '';
        this.filterApplications();
        this.isApplicationSidebarOpen = true;
        this.markForCheck();
    }

    hideApplicationSidebar() {
        if (!this.isApplicationSidebarOpen && !this.applicationSearchString) {
            return;
        }
        this.isApplicationSidebarOpen = false;
        this.applicationSearchString = '';
        this.applicationSidebarEmpty = false;
        this.filterApplications();
        this.markForCheck();
    }

    filterApplications() {
        const query = (this.applicationSearchString || '').trim().toLowerCase();
        const source = this.applications ?? [];
        this.applicationsForSearch = query
            ? source.filter((app) => (app.applicationName || '').toLowerCase().includes(query))
            : source.slice();
        this.applicationSidebarEmpty = query.length > 0 && this.applicationsForSearch.length === 0;
        this.markForCheck();
    }

    onApplicationExportChange(val: any) {
        if (val === 1) {
            this.exportApplicationsToPdf();
        } else if (val === 3) {
            this.exportApplicationsToExcel();
        }
    }

    exportApplicationsToPdf() {
        const title = 'Applications';
        const head = [['Application Name', 'Time Spent']];
        const rows = (this.applications ?? []).map((app) => [app.applicationName, this.timerToMinsHrsSecs(app.spendTime)]);
        const doc = new jsPDF('p', 'pt');
        doc.text('Tracked Applications', 40, 30);
        doc.setFontSize(7);
        doc.setTextColor(100);
        (doc as any).autoTable({
            head: head,
            body: rows,
            theme: 'grid',
            tableLineColor: [189, 195, 199],
            tableLineWidth: 0.75,
            startY: 40,
            margin: { top: 60 },
            styles: { fontSize: 9 },
        });
        doc.save(`${title}.pdf`);
    }

    exportApplicationsToExcel() {
        const title = 'Applications';
        const head = ['Application Name', 'Time Spent'];
        const rows = (this.applications ?? []).map((app) => [app.applicationName, this.timerToMinsHrsSecs(app.spendTime)]);
        const colWidth = head.map((column, index) =>
            Math.max(column.length, ...rows.map((row) => (row[index] ? String(row[index]).length : 0)))
        );
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Tracked Apps');
        worksheet.addRow([]);
        worksheet.addRow(head);
        rows.forEach((row) => worksheet.addRow(row));
        colWidth.forEach((width, index) => worksheet.columns[index].width = width);
        workbook.xlsx.writeBuffer().then((data) => {
            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            fs.saveAs(blob, title + '.xlsx');
        });
    }
    legendClickHandler(e) {
        const arg = e.target;
        const item = e.component.getAllSeries()[0].getPointsByArg(arg)[0];
    }
    timerToMinsHrsSecs(timer: string): string {
        if (!timer)
            timer = '00:00:00';
        let hrsStr = (timer.split(':')[0]);
        let minsStr = timer.split(':')[1];
        let secsStr = timer.split(':')[2];
        let hrs = Math.floor(parseFloat(hrsStr));
        let mins = Math.floor(parseFloat(minsStr));
        let secs = Math.floor(parseFloat(secsStr));
        if (mins == 0 && hrs == 0) {
            return `${secs}s`;
        }
        else if (hrs == 0) {
            return `${mins}m`;
        }
        return `${hrs}h ${mins}m`;
    }
    ShowDetails = false;
    LoadingStarted = false;
    HistoryForApp = "";
    HistoryDetails = [];
    GetData(appName: string) {
        this.HistoryForApp = appName;
        this.ShowDetails = false;
        document.getElementsByClassName('popTemplateClass')[0].className += ' display-none';
        this.LoadingStarted = true;
        this._activitesServiceProxy.getActiveWindowsHistoryForApp(appName, DateTime.fromJSDate(this.setZeroTimeForLocalDate(new Date())), this.userId, this.tenantId).subscribe(res => {
            this.HistoryDetails = res;
            this.LoadingStarted = false;
            this.HistoryForApp = "";
            if (this.HistoryDetails.length > 0) {
                this.ShowDetails = true;
                let element = document.getElementsByClassName('popTemplateClass');
                for (let i = 0; i < element.length; i++) {
                    element[i].className = element[i].className.replace(/\bdisplay-none\b/, "");
                }
            }
            else {
                this.ShowDetails = false;
                if (document?.getElementsByClassName('popTemplateClass')[0]?.className) {
                    document.getElementsByClassName('popTemplateClass')[0].className += ' display-none';
                }
            }
            this.markForCheck();
        });
    }
    setZeroTimeForLocalDate(date: Date): Date {
        date.setHours(0, 0, 0, 0);
        return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    }
    removeData() {
        this.HistoryForApp = "";
        this.LoadingStarted = false;
        this.ShowDetails = false;
        this.HistoryDetails = [];
    }
}
